/**
+ * JSON Schema for the phone object.
+ *
+ * http://json-schema.org/
+ */
export default {
  id: "phoneSchema",
  type: "object",
  properties: {
    phoneNumber: {
      type: "string",
      required: true
    },
    config: {
      type: "object",
      properties: {
        country: {
          type: "string",
          required: false
        }
      }
    }
  }
};
